import { IMG_HOST, S3_URL } from "@/config/api";
import { addZero } from "@/lib/commonService";
import murmurhash3 from "@/lib/murmurhash3";
import { uploadImg } from "../models/uploadImg";

export function getFileHash(fileName: string, small = false): string {
    const date: any = new Date();
    const time = Date.parse(date);
    fileName += time.toString();
    if (small) {
        return "small-" + murmurhash3.x86.hash128(fileName).toString();
    }
    return murmurhash3.x86.hash32(fileName).toString();
}

export function getS3Folder(
    folder = "images/users",
    time = false,
): string | { folder: string; timestamp: number } {
    const date: any = new Date();
    const timestamp = Math.floor(Date.parse(date) / 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const floder = `${folder}/${year}/${addZero(month)}${addZero(day)}/`;
    if (time) return { folder: floder, timestamp };
    return floder;
}

export interface IFile {
    name: string;
    type: string;
    fileType: string;
}

function getFileType(file: IFile): string {
    let fileType = file.type;
    const arr = fileType.split("/");
    fileType = arr[arr.length - 1];
    return fileType;
}

export class Upload {
    private file: IFile;
    private fileType: string;
    private fileName: string;

    constructor(file: IFile, small: boolean) {
        this.file = file;
        this.fileType = getFileType(file);
        this.fileName =
            getS3Folder() + getFileHash(file.name) + "." + this.fileType;
    }
    async sub(blob: Blob): Promise<void> {
        try {
            const fd = new FormData();
            fd.append("key", this.fileName);
            fd.append("acl", "public-read");
            fd.append("Content-Type", this.file.type);
            fd.append("file", blob);
            fd.append("path", this.fileName);
            const result = await uploadImg(fd);
            // Process the result if needed
        } catch (e) {
            console.log(e);
        }
    }
}

export async function imgUp(
    file: IFile,
    small = true,
    blob: Blob,
): Promise<{ img: string; date: number }> {
    const fileType = getFileType(file);
    const folder: any = getS3Folder("images/users", true);
    const fileName =
        folder.folder + getFileHash(file.name, true) + "." + fileType;

    const fd = new FormData();
    fd.append("file", blob);
    fd.append("path", fileName);

    return new Promise((resole, reject) => {
        uploadImg(fd)
            .then((result) => {
                let img = result.headers.location.replace(/%2F/g, "/");
                img = img.replace(S3_URL(), `${IMG_HOST()}/`);
                resole({ img, date: folder.timestamp });
            })
            .catch((e) => reject(e));
    });
}
